import PropTypes from "prop-types";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Icon from "../assets/icons/sof--png.png";
import SidebarMenuLinks from "./navigation/SidebarMenuLinks";
import SidebarNavFooter from "./navigation/SidebarNavFooter";

export default function SidebarNav({ collapsed, onToggleCollapse }) {
    const { t } = useTranslation("sidebar");

    return (
        <div className="relative flex h-full w-full flex-col rounded-[20px] border-none bg-[#5D5DF6] outline-none 2xl:rounded-[25px]">
            <Button
                type="text"
                shape="circle"
                size="small"
                icon={collapsed ? <RightOutlined /> : <LeftOutlined />}
                onClick={onToggleCollapse}
                aria-label={collapsed ? t("expandSidebar") : t("collapseSidebar")}
                title={collapsed ? t("expandSidebar") : t("collapseSidebar")}
                className="absolute top-6 z-20 -right-2.5 !flex !h-6 !w-6 !min-w-6 items-center justify-center !rounded-full !border !border-[#2525ff78] !bg-white !p-0 !text-[10px] !text-[#5D5DF6] shadow-sm hover:!border-[#5D5DF6] hover:!bg-[#F2F2FA] hover:!text-[#5D5DF6] xl:top-8 2xl:top-10"
            />

            <div className="mb-2 mt-5 flex items-center justify-center px-2 2xl:mt-10 xl:px-4">
                <Link to="/" className="flex justify-center">
                    <img
                        src={Icon}
                        alt="icon"
                        className={
                            collapsed
                                ? "max-h-8 max-w-[2rem]"
                                : "max-h-9 max-w-[2.25rem] xl:max-h-10 xl:max-w-[2.5rem] 2xl:max-h-full 2xl:max-w-full"
                        }
                    />
                </Link>
            </div>

            <SidebarMenuLinks collapsed={collapsed} />

            <div className="absolute bottom-[4%] w-full">
                <SidebarNavFooter collapsed={collapsed} />
            </div>
        </div>
    );
}

SidebarNav.propTypes = {
    collapsed: PropTypes.bool.isRequired,
    onToggleCollapse: PropTypes.func.isRequired,
};
